import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'


export const cscBypassButton = {
  top: css`var(--csc-bypass-button-top, ${csSpacing.spacing01})`,
  left: css`var(--csc-bypass-button-left, ${csSpacing.spacing01})`
}

export const style: CSSResult = css`
  .csc-bypass-button {
    display: block;
    margin: 0;
    padding: 0;
    width: 1px;
    position: absolute;
    clip: rect(1px 1px 1px 1px);
    clip: rect(1px,1px,1px,1px);
    overflow: hidden;
    height: 1px;
    top: ${cscBypassButton.top};
    left: ${cscBypassButton.left};
    color: #555;
    background-color: #fff;
  }

  .csc-bypass-button:active,
  .csc-bypass-button:focus {
    position: absolute;
    clip: auto;
    overflow: visible;
    height: auto;
    width: auto;
    z-index: 999;
  }
`
